<template>
  <div class="main-view">
    <!-- 筛选 -->
    <el-col>
      <el-card class="searchCard" shadow="never">
        <el-form inline class="inline-form">
          <el-form-item label="创建时间">
            <el-date-picker
              v-model="creatTime"
              type="daterange"
              align="left"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="活动金编号">
            <el-input class="search-input" v-model="activityId" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select style="width: 120px;" v-model="status" clearable>
              <el-option label="待审核" value="0"></el-option>
              <el-option label="审核通过" value="1"></el-option>
              <el-option label="审核退回" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <auth-button opt="search" :plain="true" icon="el-icon-search" @click.native="searchClick" label="查询"></auth-button>
          </el-form-item>
          <el-form-item>
            <auth-button opt="money_entry" icon="el-icon-top" @click.native="moneyEntryCilck" label="活动金录入"></auth-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-col>
    <el-card class="tableCard" shadow="never">
      <!-- 活动金管理table -->
      <el-table
        stripe
        style="width:100%;"
        :data="eventMoenyList"
        :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
          prop="fCreateTime"
          label="创建时间"
          align="center"
          min-width="230">
        </el-table-column>
        <el-table-column
          prop="fActivityId"
          label="活动金编号"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="fActivityMoney"
          label="充值金额(元)"
          align="center"
          min-width="250">
          <template slot-scope="scope">
            <div>{{ formatAmountFenToYuan(scope.row.fActivityMoney) }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="fActivityDescription"
          label="充值摘要"
          align="center"
          min-width="220">
        </el-table-column>
        <el-table-column
          prop="fPaymentCardLastFourNum"
          label="付款账户后4位"
          align="center"
          min-width="180">
        </el-table-column>
        <el-table-column
          prop="fStatus"
          label="状态"
          align="center"
          min-width="180">
          <template slot-scope="scope">
            <div>{{ formatStatus(scope.row.fStatus) }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          min-width="250">
          <template slot-scope="scope">
            <auth-button
              opt="edit"
              type="text"
              v-if="scope.row.fStatus === 2"
              label="修改"
              @click.native="handleEdite(scope.$index, scope.row)"></auth-button>
            <auth-button
              opt="details"
              type="text"
              v-else
              label="查看"
              @click.native="handleInfo(scope.$index, scope.row)"></auth-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-col :span="24" class="btm-action">
      <el-pagination
        v-if="paginations.count > 0"
        class="pagination"
        :page-size="paginations.pageSize"
        layout="total, prev, pager, next, jumper"
        :total="paginations.count"
        :current-page="paginations.pageNo"
        @current-change="onChangeCurrentPage">
      </el-pagination>
    </el-col>
    <!-- 活动金录入/修改dialog -->
    <el-dialog
      :title="isEditeMoneyInfo ? '活动金修改' : '活动金录入'"
      :visible.sync="moneyInfoEntryDialogVisible"
      width="40%"
      @close="$refs['moneyInfoEntryform'].resetFields()">
      <div v-loading="moneyEntryInfoDialogLoading">
        <el-form ref="moneyInfoEntryform" :model="moneyEntryInfo" :rules="moneyEntryInfoRules" label-width="150px" label-position="left">
          <el-form-item label="活动金编号" prop="FActivityId" v-if="isEditeMoneyInfo">
            <el-input class="info-dialog-form-item" v-model="moneyEntryInfo.FActivityId" disabled></el-input>
          </el-form-item>
          <el-form-item label="充值金额" prop="FActivityMoney">
            <el-input class="entry-dialog-form-item" v-model.number="moneyEntryInfo.FActivityMoney" ></el-input>
          </el-form-item>
          <el-form-item label="充值时间" prop="FRechargeTime">
            <el-date-picker
              class="entry-dialog-form-item"
              v-model="moneyEntryInfo.FRechargeTime"
              type="datetime"
              placeholder="选择日期"
              :pickerOptions="{
                disabledDate(time) {
                  return time.getTime() > Date.now() - 8.64e6
                }
              }"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="充值摘要" prop="FActivityDescription">
            <el-input class="entry-dialog-form-item" type="textarea" placeholder="选填" v-model="moneyEntryInfo.FActivityDescription"></el-input>
          </el-form-item>
          <el-form-item label="付款银行" prop="FPaymentBankName">
            <el-input class="entry-dialog-form-item" v-model="moneyEntryInfo.FPaymentBankName"></el-input>
          </el-form-item>
          <el-form-item label="付款账号后4位" prop="FPaymentCardLastFourNum">
            <el-input class="entry-dialog-form-item" v-model="moneyEntryInfo.FPaymentCardLastFourNum"></el-input>
          </el-form-item>
          <el-form-item label="乐刷收款银行" prop="FChargeBankName">
            <el-input class="entry-dialog-form-item" v-model="moneyEntryInfo.FChargeBankName"></el-input>
          </el-form-item>
          <el-form-item label="乐刷收款账号后4位" prop="FChargeCardLastFourNum">
            <el-input class="entry-dialog-form-item" v-model="moneyEntryInfo.FChargeCardLastFourNum"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="FRemark">
            <el-input class="entry-dialog-form-item" type="textarea" placeholder="选填" v-model="moneyEntryInfo.FRemark"></el-input>
          </el-form-item>
          <el-form-item label="凭证" prop="FConfirmPicId">
            <VueImgInputer
              v-model="moneyEntryInfo.FConfirmPicId"
              theme="light"
              accept="image/*"
              @onChange="handleUpload('invoicePic')"
              v-loading="isPicUploading"
              placeholder="点击上传"
              :imgSrc="certificatePicPath"></VueImgInputer>
            <div style="cursor: pointer; text-decoration: underline;" v-if="certificatePicPath" @click="certificateImgDialogVisible = true">点击查看大图</div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button @click="moneyInfoEntryDialogVisible = false" >取 消</el-button>
        <el-button type="primary" @click="moneyInfoEntrySubmitClick">提 交</el-button>
      </span>
    </el-dialog>
    <!-- 凭证图片预览dialog -->
    <el-dialog
      :visible.sync="certificateImgDialogVisible"
      width="50%"
      center>
      <img style="width: 100%;" :src="certificatePicPath">
    </el-dialog>
    <!-- 活动金查看dialog -->
    <el-dialog
      title="活动金查看"
      :visible.sync="moneyInfoDialogVisible"
      width="50%">
      <div>
        <el-form ref="moneyInfoform" :model="moneyInfo" label-width="140px" label-position="left" inline>
          <el-form-item label="充值金额" prop="fActivityMoney">
            <el-input class="info-dialog-form-item" v-model.number="moneyInfo.fActivityMoney" disabled></el-input>
          </el-form-item>
          <el-form-item label="活动金编号" prop="fActivityId">
            <el-input class="info-dialog-form-item" v-model.number="moneyInfo.fActivityId" disabled></el-input>
          </el-form-item>
          <el-form-item label="充值时间" prop="fRechargeTime">
            <el-date-picker
              class="info-dialog-form-item"
              v-model="moneyInfo.fRechargeTime"
              type="datetime"
              :pickerOptions="{
                disabledDate(time) {
                  return time.getTime() > Date.now() - 8.64e6
                }
              }"
              value-format="yyyy-MM-dd HH:mm:ss"
              disabled>
            </el-date-picker>
          </el-form-item>
          <el-form-item label="创建时间" prop="fCreateTime">
            <el-date-picker
              class="info-dialog-form-item"
              v-model="moneyInfo.fCreateTime"
              type="datetime"
              :pickerOptions="{
                disabledDate(time) {
                  return time.getTime() > Date.now() - 8.64e6
                }
              }"
              value-format="yyyy-MM-dd HH:mm:ss"
              disabled>
            </el-date-picker>
          </el-form-item>
          <el-form-item label="充值摘要" prop="fActivityDescription">
            <el-input class="info-dialog-form-item" type="textarea" v-model="moneyInfo.fActivityDescription" disabled></el-input>
          </el-form-item>
          <el-form-item label="录入人" prop="fCreatorAccount">
            <el-input class="info-dialog-form-item" v-model="moneyInfo.fCreatorAccount" disabled></el-input>
          </el-form-item>
          <el-form-item label="付款银行" prop="fPaymentBankName">
            <el-input class="info-dialog-form-item" type="textarea" v-model="moneyInfo.fPaymentBankName" disabled></el-input>
          </el-form-item>
          <el-form-item label="审核状态" prop="fStatusStr">
            <el-input class="info-dialog-form-item" v-model="moneyInfo.fStatusStr" disabled></el-input>
          </el-form-item>
          <el-form-item label="付款账号后4位" prop="fPaymentCardLastFourNum">
            <el-input class="info-dialog-form-item" v-model="moneyInfo.fPaymentCardLastFourNum" disabled></el-input>
          </el-form-item>
          <el-form-item label="审核时间" prop="fCheckTime">
            <el-date-picker
              class="info-dialog-form-item"
              v-model="moneyInfo.fCheckTime"
              type="datetime"
              :pickerOptions="{
                disabledDate(time) {
                  return time.getTime() > Date.now() - 8.64e6
                }
              }"
              value-format="yyyy-MM-dd HH:mm:ss"
              disabled>
            </el-date-picker>
          </el-form-item>
          <el-form-item label="乐刷收款银行" prop="fChargeBankName">
            <el-input class="info-dialog-form-item" type="textarea" v-model="moneyInfo.fChargeBankName" disabled></el-input>
          </el-form-item>
          <el-form-item label="审核描述" prop="fCheckDescription">
            <el-input class="info-dialog-form-item" type="textarea" v-model="moneyInfo.fCheckDescription" disabled></el-input>
          </el-form-item>
          <el-form-item label="乐刷收款账号后4位" prop="fChargeCardLastFourNum">
            <el-input class="info-dialog-form-item" v-model="moneyInfo.fChargeCardLastFourNum" disabled></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="fRemark">
            <el-input class="info-dialog-form-item" type="textarea" v-model="moneyInfo.fRemark" disabled></el-input>
          </el-form-item>
          <el-form-item></el-form-item>
          <el-form-item label="凭证" prop="certificateImg">
            <div style="cursor: pointer; text-decoration: underline;" @click="certificateImgDialogVisible = true">点击查看</div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button @click="moneyInfoDialogVisible = false" >取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import VueImgInputer from 'vue-img-inputer'
import { listSubsidy, addOrUpdateSubsidy, getSgentSubsidyDetail } from '@/api/activity'
import { uploadPic } from '@/api/global'
export default {
  name: 'MoneyInfo',
  components: { VueImgInputer },
  data () {
    const twoDecimalReg = /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/
    return {
      loading: false,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '昨天',
          onClick (picker) {
            // 精确到日
            const start = new Date()
            const end = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24)
            end.setTime(end.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      // 需要给分页组件传的信息
      paginations: {
        pageNo: 1,
        count: 0,
        pageSize: 10
      },
      // 搜索表单信息
      searchInfo: {
        FStartTime: '',
        FEndTime: '',
        FActivityId: '',
        FStatus: ''
      },
      creatTime: '',
      activityId: '',
      status: '',
      eventMoenyList: [],
      isEditeMoneyInfo: false,
      moneyInfoEntryDialogVisible: false,
      moneyEntryInfoDialogLoading: false,
      moneyEntryInfoRules: {
        FActivityMoney: [
          { type: 'number', required: true, message: '请输入正确的充值金额', trigger: 'blur' },
          { pattern: twoDecimalReg, message: '充值金额最多2位小数' },
          {
            validator: (rule, value, callback) => {
              if (value < 0.01) {
                callback(new Error('充值金额不能低于0.01'))
              } else if (value > 1000000) {
                callback(new Error('充值金额不能高于1百万'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        FRechargeTime: [
          { required: true, message: '请选择充值时间时间' }
        ],
        FActivityDescription: [
          { max: 30, message: '充值摘要不能超过30个字', trigger: 'blur' }
        ],
        FPaymentBankName: [
          { required: true, message: '请输入付款银行名', trigger: 'blur' },
          { max: 30, message: '付款银行名不能超过30个字', trigger: 'blur' }
        ],
        FPaymentCardLastFourNum: [
          { required: true, message: '请输入付款账号后4位', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value.length !== 4 || isNaN(value)) {
                callback(new Error('请输入付款账号后4位'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        FChargeBankName: [
          { required: true, message: '请输入乐刷收款银行名', trigger: 'blur' },
          { max: 30, message: '乐刷收款银行名不能超过30个字', trigger: 'blur' }
        ],
        FChargeCardLastFourNum: [
          { required: true, message: '请输入乐刷收款账号后4位', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value.length !== 4 || isNaN(value)) {
                callback(new Error('请输入乐刷收款账号后4位'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        FRemark: [
          { max: 30, message: '备注不能超过30个字', trigger: 'blur' }
        ],
        FConfirmPicId: [
          { required: true, message: '请上传凭证' }
        ]
      },
      moneyEntryInfo: {
        FActivityMoney: '',
        FRechargeTime: '',
        FActivityDescription: '',
        FPaymentBankName: '',
        FPaymentCardLastFourNum: '',
        FChargeBankName: '',
        FChargeCardLastFourNum: '',
        FRemark: '',
        FConfirmPicId: ''
      },
      certificateImgDialogVisible: false,
      isPicUploading: false,
      certificatePicPath: '',
      moneyInfo: {},
      moneyInfoDialogVisible: false,
      moneyInfoDialogLoading: false
    }
  },
  mounted () {
    this.searchClick()
  },
  beforeDestroy () {},
  methods: {
    /**
     * 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage (page) {
      this.paginations.pageNo = page
      this.searchClick(true)
    },
    /**
     * 筛选查询按钮点击
     */
    searchClick (noReset) {
      this.searchInfo.FStartTime = this.creatTime && this.creatTime[0] ? this.creatTime[0] : ''
      this.searchInfo.FEndTime = this.creatTime && this.creatTime[1] ? this.creatTime[1] : ''
      this.searchInfo.FActivityId = this.activityId || ''
      this.searchInfo.FStatus = this.status || ''
      this.formatParams(this.searchInfo)
      if (noReset !== true) {
        this.paginations.pageNo = 1
        this.paginations.count = 0
      }
      this.searchInfo = Object.assign(this.searchInfo, this.paginations)
      this.listSubsidyFn()
    },
    /**
     * 删除提交参数中的空字段
     */
    formatParams (params) {
      for (const key in params) {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(key) && !params[key] && params[key] !== 0) {
          delete params[key]
        }
      }
    },
    /**
     * 活动金录入按钮点击
     */
    moneyEntryCilck () {
      console.log('活动金录入点击')
      this.resetMoneyEntryInfo()
      this.isEditeMoneyInfo = false
      this.moneyInfoEntryDialogVisible = true
    },
    /**
     * 记录查看按钮点击
     */
    handleInfo (index, row, scope) {
      console.log(`index: ${index}, row: `, row)
      this.getSgentSubsidyDetailFn(row.fActivityId)
      this.moneyInfoDialogVisible = true
    },
    /**
     * 记录修改按钮点击
     */
    handleEdite (index, row, scope) {
      console.log(`index: ${index}, row: `, row)
      this.resetMoneyEntryInfo()
      const info = JSON.parse(JSON.stringify(row))
      for (const key in info) {
        // eslint-disable-next-line no-prototype-builtins
        if (info.hasOwnProperty(key)) {
          const element = info[key]
          const upperKey = key.substring(0, 1).toUpperCase() + key.substring(1)
          info[upperKey] = element
          delete info[key]
        }
      }
      delete info.FCreateTime
      this.moneyEntryInfo = info
      this.moneyEntryInfo.FActivityMoney = this.formatAmountFenToYuan(info.FActivityMoney)
      this.certificatePicPath = info.FShowAddress
      this.isEditeMoneyInfo = true
      this.moneyInfoEntryDialogVisible = true
    },
    /**
     * 重置活动金信息
     */
    resetMoneyEntryInfo () {
      this.moneyEntryInfo = {
        FActivityMoney: '',
        FRechargeTime: '',
        FActivityDescription: '',
        FPaymentBankName: '',
        FPaymentCardLastFourNum: '',
        FChargeBankName: '',
        FChargeCardLastFourNum: '',
        FRemark: '',
        FConfirmPicId: ''
      }
      this.certificatePicPath = ''
    },
    /**
     * 上传图片
     * @param  {string} type 上传图片的种类
     */
    handleUpload (type) {
      this.isPicUploading = true
      const reader = new FileReader()
      reader.readAsDataURL(this.moneyEntryInfo.FConfirmPicId)
      reader.onload = () => {
        let file = reader.result
        this.certificatePicPath = file
        file = file.split('base64,')
        let data = {
          base64pic: file[1],
          filename: this.moneyEntryInfo.FConfirmPicId.name
        }
        data = qs.stringify(data)
        uploadPic(data).then(response => {
          this.isPicUploading = false
          console.log(response)
          if (response.error_code === '0') {
            this.moneyEntryInfo.FConfirmPicId = response.path
            this.certificatePicPath = response.showPath
            this.$message({
              message: '凭证上传成功',
              type: 'success'
            })
          } else {
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
          }
        })
      }
    },
    /**
     * 录入确定按钮点击
     */
    moneyInfoEntrySubmitClick () {
      console.log('录入确定按钮点击')
      this.$refs.moneyInfoEntryform.validate((valid) => {
        if (valid) {
          this.moneyEntryInfo.FActivityMoney = Number(this.moneyEntryInfo.FActivityMoney).toFixed(2) * 100
          this.formatParams(this.moneyEntryInfo)
          this.addOrUpdateSubsidyFn(this.moneyEntryInfo)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    /**
     * 格式化审核状态
     */
    formatStatus (value) {
      switch (value) {
        case 0:
          return '待审核'
        case 1:
          return '审核通过'
        case 2:
          return '审核退回'
        default:
          return '未知'
      }
    },
    /**
     * 格式化金额分为元
     */
    formatAmountFenToYuan (value) {
      return value ? parseFloat(parseFloat(value).toFixed(2) / 100).toFixed(2) : ''
    },
    /**
     * 活动金信息管理列表
     */
    listSubsidyFn () {
      const params = qs.stringify(this.searchInfo)
      listSubsidy(params).then(response => {
        if (response.error_code === '0') {
          this.eventMoenyList = response.data.list
          this.paginations.count = response.data.totalCount
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    /**
     * 活动金录入/修改
     * @param {Object} info 活动金信息对象
     */
    addOrUpdateSubsidyFn (info) {
      this.moneyEntryInfoDialogLoading = true
      const params = qs.stringify(info)
      console.log(params)
      addOrUpdateSubsidy(params).then(response => {
        this.moneyEntryInfoDialogLoading = false
        console.log('addOrUpdateSubsidy response:', response)
        if (response.error_code === '0') {
          this.$message({
            message: `活动金${this.isEditeMoneyInfo ? '修改' : '录入'}成功`,
            type: 'success'
          })
          this.moneyInfoEntryDialogVisible = false
          this.searchClick(true)
        } else {
          this.moneyEntryInfo.FActivityMoney = this.formatAmountFenToYuan(this.moneyEntryInfo.FActivityMoney)
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    /**
     * 活动金查看
     * @param {String} activityId 活动金编号
     */
    getSgentSubsidyDetailFn (activityId) {
      this.moneyInfoDialogLoading = true
      const params = qs.stringify({ FActivityId: activityId })
      console.log(params)
      getSgentSubsidyDetail(params).then(response => {
        this.moneyInfoDialogLoading = false
        console.log('getSgentSubsidyDetail response:', response)
        if (response.error_code === '0') {
          this.moneyInfo = response.data
          this.certificatePicPath = this.moneyInfo.fShowAddress
          this.moneyInfo.fActivityMoney = this.formatAmountFenToYuan(this.moneyInfo.fActivityMoney)
          this.moneyInfo.fStatusStr = this.formatStatus(this.moneyInfo.fStatus)
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    }
  },
  computed: {},
  filters: {}
}
</script>

<style scoped>
.main-view {
  padding-left: 16px;
}
.btm-action {
  margin: 20px 0;
  text-align: center;
}
.entry-dialog-form-item {
  width: 260px;
}
.info-dialog-form-item {
  width: 260px;
  margin-right: 30px;
}
</style>
